import { AbstractControl, NgControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { CompanyValues } from "./CompanyValues";

/**
 * Valida que password1 y password2 sean iguales para
 */
export function PasswordsValidator(control: AbstractControl): ValidationErrors | null {
	let p1 = control.get("password1")!.value as string;
	let p2 = control.get("password2")!.value as string;
	if (p1 != p2) {
		return { PasswordsDontMatch: true };
	} else {
		return null;
	}
}

/**
 * Verifica que al menos un valor sea seleccionado en el formulario de producto
 */
export function ProductValuesValidator(control: AbstractControl): ValidationErrors | null {
	let values = CompanyValues;

	for (let f = 0; f < values.length; f++) {
		if (control.get("value" + f)!.value == true) {
			return null;
		}
	}
	return { missingValues: true }
}

/**
 * Valida que min y max sean coherentes. Permite null
 */
export function MinMaxValidator(control: AbstractControl): ValidationErrors | null {
	let min = parseInt(control.get("min")!.value);
	let max = parseInt(control.get("max")!.value);

	if (min && max && min >= max) {
		return { InvalidMinMax: true };
	} else {
		return null;
	}
}

/**
 * Validar que el precio con descuento sea mayor al shipping price
 */
export function PriceWithDiscountValidator(shippingPrice:number) : ValidatorFn {
	return (control:AbstractControl) : ValidationErrors | null => {
		let freeDelivery = control.get("freeDelivery")!.value;		
		if (!freeDelivery)
			return null;

		let price = parseInt(control.get("price")!.value);
		let discount = parseInt(control.get("discount")!.value);
		
		if (!discount)
			discount = 0;

		return price * (100-discount)/100 > shippingPrice ? null : { PriceSmallerThanShippingPrice: true };
	}
}

/**
 * Valida que la dirección tenga localidad en CABA
 */
export function AddressMustBeWithinCABAValidator(control: AbstractControl): ValidationErrors | null {
	let state : string = control.get("state")!.value;

	if (state && state.length && state.toUpperCase() != "CABA") {
		return { NotWithinCABA: true };
	} else {
		return null;
	}
}